import IRLogoFull from "./images/logo-full.svg";
import IRLogoCompact from "./images/logo-compacts.svg";
import IrLogoText from "./images/logo-text.svg";

export const assetsImages = {
  IRLogoFull,
  IRLogoCompact,
  IrLogoText,
};
